<div class="grid-container">

  <div class="toolbar">
    @if(appIds()?.designId && user()){
      <app-toolbar #toolbar [user]="user()"></app-toolbar>
      <app-dashboard [user]="user()"></app-dashboard>
    }
  </div>

  <div class="sidebar">
    <app-sidebar-menu></app-sidebar-menu>
  </div>
  
  <div class="dashboard">
    @if (!appIds()?.designId) {
      <app-no-current-design></app-no-current-design>
    }
  </div>
  
  @if(showWellSchematic()){
    <div class="schematic">
        <div class="grabber" appResizer (resizeDone)="requestSchematicRedraw()" minWidth="150" maxWidth="650"></div>
        <div class="pad">
          <app-well-schematic #schematic isSidebarComp="true"></app-well-schematic>
        </div>
    </div>
  }

</div>